import React from "react"
import PlasticsDescription from "../environment/en/PlasticsDescription"
import DisposalDescription from "../environment/en/DisposalDescription"

const Details = props => {
  if (props.type === "plastics") {
    return <PlasticsDescription />
  } else if (props.type === "disposal") {
    return <DisposalDescription />
  } else {
    return <div></div>
  }
}

export default Details
